import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";

export default function LogoutConfirm({ isOpen, onCancel, onConfirm }) {
  if (!isOpen) return null;

  const mono = "'JetBrains Mono', 'Fira Code', monospace";

  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.75)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "var(--bg-card)",
          border: "1px solid #ff525250",
          borderRadius: "14px",
          padding: "26px",
          maxWidth: "380px",
          width: "100%",
          boxShadow: "0 10px 30px rgba(0,0,0,0.6), 0 0 20px rgba(255,82,82,0.1)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            background: "rgba(255,82,82,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            border: "1px solid rgba(255,82,82,0.25)",
          }}
        >
          <LogOut size={22} color="#ff5252" />
        </div>
        <h3
          style={{
            fontSize: "16px",
            fontWeight: 700,
            margin: "0 0 8px",
            color: "var(--text-main)",
            fontFamily: "inherit",
          }}
        >
          Confirm Session Disconnect
        </h3>
        <p
          style={{
            fontSize: "12px",
            color: "var(--text-muted)",
            margin: "0 0 24px",
            lineHeight: 1.5,
            fontFamily: "inherit",
          }}
        >
          Are you sure you want to log out of Algo Masters? Your active session will be cleared.
        </p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              background: "var(--bg-field)",
              border: "1px solid var(--border-field)",
              borderRadius: "6px",
              color: "var(--text-main)",
              padding: "10px",
              fontSize: "12px",
              fontWeight: 700,
              fontFamily: mono,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              background: "#da3637",
              border: "none",
              borderRadius: "6px",
              color: "#ffffff",
              padding: "10px",
              fontSize: "12px",
              fontWeight: 700,
              fontFamily: mono,
              cursor: "pointer",
            }}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
